import header from 'components/navigation/Header/lib/header';

document.addEventListener('DOMContentLoaded', () => {
  header();
});
